export default __webpack_public_path__ + "static/media/message.0817ef5b.svg";